import React, { useCallback, useEffect, useMemo, useState } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import debounce from 'lodash/debounce';
import noop from 'lodash/noop';
import { useIntl } from 'react-intl-next';
import { fg } from '@atlaskit/platform-feature-flags';
import TextArea from '@atlaskit/textarea';
import { messages } from './messages';
export const EditOtherOption = ({
  dropdown,
  isDisabled,
  value,
  onChange,
  id
}) => {
  const intl = useIntl();

  // Local state required to show textarea changes as onChange callback is debounced.
  // Without it, user will only see their last inputted character added within the debounce period.
  const [textAreaValue, setTextAreaValue] = useState(value);
  useEffect(() => {
    if (fg('debounce_proforma_text_field_edits')) {
      setTextAreaValue(value);
    }
  }, [value]);
  const debouncedOnChange = useMemo(() => fg('debounce_proforma_text_field_edits') ? onChange ? debounce(onChange, 500) : noop : noop, [onChange]);
  const handleTextAreaChange = useCallback(e => {
    e.persist();
    setTextAreaValue(e.target.value);
    debouncedOnChange(e);
  }, [debouncedOnChange]);
  const TextWrapper = dropdown ? OptionalTextWrapperDropdown : OptionalTextWrapper;
  return /*#__PURE__*/React.createElement(TextWrapper, null, /*#__PURE__*/React.createElement(TextArea, {
    appearance: "standard",
    isCompact: false,
    placeholder: intl.formatMessage(messages.choiceDropdownNewOption),
    isDisabled: isDisabled,
    isReadOnly: false,
    minimumRows: 2,
    maxHeight: "none",
    isMonospaced: false,
    value: fg('debounce_proforma_text_field_edits') ? textAreaValue : value,
    resize: "smart",
    spellCheck: false,
    onBlur: undefined,
    onChange: fg('debounce_proforma_text_field_edits') ? handleTextAreaChange : event => {
      onChange ? onChange(event) : undefined;
    },
    onFocus: undefined,
    id: fg('proforma_add_unique_id_for_textarea_fields') ? id + '-other-option' : undefined
  }));
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const OptionalTextWrapper = styled.div({
  marginLeft: "var(--ds-space-300, 24px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const OptionalTextWrapperDropdown = styled.div({
  marginTop: "var(--ds-space-050, 4px)"
});